jQuery(function($){

    if ($('.offertemand-page').length == 0){
        return;
    }

    $(document).on('click', '.cart__upload-remove', function(e) {
        console.log('asd');
        e.stopPropagation();
        e.preventDefault();
    
        const $parent = $(this).closest('.cart__upload-wrap'); // Parent div containing this file
        const fileName = $parent.find('strong').text(); // Get the filename
    
        if (!fileName) return;
    
        $.ajax({
            url: wemake.ajax_url,
            type: 'POST',
            data: {
                action: 'remove_cart_image',
                _wpnonce: wemake.nonce,
                file_name: fileName
            },
            beforeSend: function() {
                $parent.css('opacity', '0.5');
            },
            success: function(response) {
                if (response.success) {
                    $parent.remove(); // Remove from DOM if success
                } else {
                    console.log('Remove error: ', response);
                    $parent.css('opacity', '1');
                }
            },
            error: function(error) {
                console.log('Remove error: ', error);
                $parent.css('opacity', '1');
            }
        });
    });

    
    $(document).on('change', '.cart__upload-input', function () {
        const files = this.files;
        if (!files.length) return;
    
        const formData = new FormData();
        formData.append('action', 'upload_cart_images');
        formData.append('_wpnonce', wemake.nonce);
    
        for (let i = 0; i < files.length; i++) {
            formData.append('custom_upload_images[]', files[i]);
        }
    
        $.ajax({
            url: wemake.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function () {
                $('.cart__upload .cart__upload-content').remove();
                $('.cart__upload').append('<div class="cart__upload-content d-f fd-c gap-16"></div>');
                $('.cart__upload-content').html('<div class="spinner-loader"></div>');
            },
            success: function (response) {
                if (response.success) {
                    console.log('Upload success:', response.data.files);
                    $('.cart__upload .cart__upload-content').remove();
                    $('.cart__upload').append('<div class="cart__upload-content d-f fd-c gap-16"></div>');
    
                    response.data.files.forEach(function (file) {
                        const isPdf = file.url.toLowerCase().endsWith('.pdf');
    
                        const fileHtml = `
                            <div class="cart__upload-wrap d-f f-a-c gap-8 fw-n p-r">
                                ${isPdf ? `<img width="60" height="60" class="cart__upload-img cover br-circle border-grey white p-8" src="/wp-content/themes/wemake/images/pdf-icon.png" alt="PDF">` : `<img width="60" height="60" class="cart__upload-img cover br-circle border-grey white p-8" src="${file.url}" alt="Upload">`}
                                <strong class="t-13">${file.name}</strong>
                                <img decoding="async" class="cart__upload-remove" width="26" height="26" src="https://env-wwwvandijkmetaaldesignnl-development.kinsta.cloud/wp-content/themes/wemake/images/close-black.svg" alt="close black">
                            </div>
                        `;
    
                        $('.cart__upload-content').append(fileHtml);
                    });
                } else {
                    console.log('Upload error: ', response);
                    $('.cart__upload-content').html('<span>Uploaden mislukt</span>');
                }
            },
            error: function (error) {
                console.log('Upload error: ', error);
                $('.cart__upload-content').html('<span>Uploaden mislukt</span>');
            }
        });
    });
    
    
    
});